import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { Card } from '../ui/Card';
import { leadSources } from '../../data/configuration';
import { formatSeconds } from '../../utils/format';
import { healthBar, healthText, pastDueHealth, speedHealth } from '../../utils/health';
interface Row {
  sourceId: string;
  leads: number;
  pastDuePct: number;
  speedToLeadSeconds: number;
  contactRate: number;
}
interface SourceTableProps {
  title: string;
  description?: string;
  rows: Row[];
  onSelect?: (sourceId: string) => void;
}
export function SourceTable({
  title,
  description,
  rows,
  onSelect
}: SourceTableProps) {
  return <Card className="overflow-hidden" data-id="element-330" data-mp="dpxxkp8lwug6">
      <div className="border-b border-ink-200 px-6 py-4" data-id="element-331" data-mp="dmtp3fo3zcjp">
        <h2 className="text-sm font-semibold text-ink-900" data-id="element-332" data-mp="8pab8gvbp1sa">{title}</h2>
        {description ? <p className="mt-0.5 text-xs text-ink-500" data-id="element-333" data-mp="1p3a81iyvgbbb">{description}</p> : null}
      </div>
      <ul className="divide-y divide-ink-200" data-id="element-334" data-mp="1k61n5amc9t6d">
        {rows.map(row => {
        const name = leadSources.find(s => s.id === row.sourceId)?.name ?? row.sourceId;
        const pd = pastDueHealth(row.pastDuePct);
        const body = <div className="grid grid-cols-2 items-center gap-4 px-6 py-4 sm:grid-cols-[1.4fr_repeat(3,1fr)_auto]" data-id="element-335" data-mp="317h5zlw2xuzh">
              <div data-id="element-336" data-mp="3a62jv3qlwltx">
                <p className="text-sm font-medium text-ink-900" data-id="element-337" data-mp="3a6kpus32mef1">{name}</p>
                <p className="tabular mt-0.5 text-xs text-ink-500" data-id="element-338" data-mp="3a3q48x8bmnk1">
                  {row.leads.toLocaleString()} leads
                </p>
              </div>
              <div data-id="element-339" data-mp="2ifo8pf9z9nly">
                <p className="text-[11px] font-medium text-ink-400" data-id="element-340" data-mp="2icsdhypild17">Past Due</p>
                <p className={`tabular text-sm font-semibold ${healthText[pd]}`} data-id="element-341" data-mp="2mex56rwejzl7">
                  {row.pastDuePct}%
                </p>
                <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-ink-100" data-id="element-342" data-mp="1upah1pvb1qrw">
                  <div className={`h-full rounded-full ${healthBar[pd]}`} style={{
                width: `${Math.min(100, row.pastDuePct * 3)}%`
              }} data-id="element-343" data-mp="1unhikxuuicuz" />
                </div>
              </div>
              <div data-id="element-344" data-mp="2x3i4bp5c56rr">
                <p className="text-[11px] font-medium text-ink-400" data-id="element-345" data-mp="2x1x8lw7abhsb">Speed to Lead</p>
                <p className={`tabular text-sm font-semibold ${healthText[speedHealth(row.speedToLeadSeconds)]}`} data-id="element-346" data-mp="3brw7k16nyx8u">
                  {formatSeconds(row.speedToLeadSeconds)}
                </p>
              </div>
              <div data-id="element-347" data-mp="2j51on8phw5xh">
                <p className="text-[11px] font-medium text-ink-400" data-id="element-348" data-mp="2e3uh9ar9l8rc">Contact Rate</p>
                <p className="tabular text-sm font-semibold text-ink-900" data-id="element-349" data-mp="2e674o3fskbbs">{row.contactRate}%</p>
              </div>
              {onSelect ? <ChevronRightIcon className="hidden h-4 w-4 justify-self-end text-ink-300 sm:block" aria-hidden="true" data-id="element-350" data-mp="2o1sa6bk2jtqa" /> : null}
            </div>;
        return <li key={row.sourceId} data-id="element-351" data-mp="3dvxb0j1a3z9">
              {onSelect ? <button type="button" onClick={() => onSelect(row.sourceId)} className="block w-full text-left transition-colors hover:bg-ink-50" data-id="element-352" data-mp="auiyqt0qll5k">
                  {body}
                </button> : body}
            </li>;
      })}
      </ul>
    </Card>;
}